import { findIndex } from 'lodash'

const mutation = {
  cardTypeListSuccess(state, { data }) {
    const res = data && data.list.map(item => {
      return item;
    })

    state.cardTypeList = res;
  },
  secretKeySuccess(state, { secret_key }) {
    state.secretKey = secret_key;
  },
  removeContactSelected(state, del_id) {
    state.selectedContacts = state.selectedContacts.filter(({ id }) => id != del_id)
  },
  setContactSelected(state, payload) {
    if (Array.isArray(payload)) {
      state.selectedContacts = payload
    } else {
      let { data, fn } = payload

      if (!data || !fn) return

      let newState = JSON.parse(JSON.stringify(state.selectedContacts))
      const selectIndex = newState.findIndex((list) => list.id == data.id)

      if (fn === 'add' && selectIndex === -1) {
        newState.push(data)
      }
      if (selectIndex !== -1) {
        if (fn === 'reduce') {
          newState.splice(selectIndex, 1)
        }
        if (fn === 'splice') {
          newState.splice(selectIndex, 1, data)
        }
      }

      state.selectedContacts = newState;
    }
  },
  contactDetailSuccess(state, { data }) {
    state.contactDetail = data
  },
  setContactVerifyParams(state, { data }) {
    state.contactVerifyParams = data
  },
  clearContactDetail(state, { data }) {
    state.contactDetail = data;
  },
  clearCardTypeList(state) {
    state.cardTypeList = [];
  },
  saveTravelerRule(state, payload) {
    state.travelerRuleDetail = payload;
  },
  checkPermissionSuccess(state, { data }) {
    state.permission = data.permission;
  },
  refreshUserCardList(state, payload) {
    state.refreshUserId = payload;
  },
  setNationality(state, payload) {
    state.nationality = payload;
  },
  setGroupCountry(state, payload) {
    state.groupCountry = payload;
  },
  setExternalContacts(state, payload) {
    let newState = JSON.parse(JSON.stringify(state.externalContacts))
    const index = findIndex(newState, item => {
      return item.id == payload.id
    });
    if (!payload.isDelet) {
      if (index !== -1) {
        newState[index] = payload
      } else {
        newState.unshift(payload)
      }
    } else {
      newState.splice(index, 1)
    }
    state.externalContacts = newState
  },
  clearExternalContacts(state, payload) {
    state.externalContacts = []
  },
}

export default mutation